import React from 'react';
import styled from 'styled-components';
import { TabList } from 'react-tabs';
import { compose, layout, margin, padding } from 'styled-system';
import { LayoutProps, MarginProps, PaddingProps } from '../../../theme/styledProps';
import { StepVariant } from './types';

interface StepListProps extends PaddingProps, MarginProps, LayoutProps {
  variant?: StepVariant;
}

export const StyledStepList = styled(TabList)<StepListProps>(
  {
    margin: 0,
    padding: 0,
    display: 'flex',
    gap: 4,
  },

  compose(margin, padding, layout),
);

interface StepListFC extends React.FC<StepListProps> {
  tabsRole: 'TabList';
}

export const StepList: StepListFC = ({ children, variant, ...props }) => {
  return (
    <StyledStepList {...props}>
      {React.Children.map(children, (child, index) => {
        const selectedIndex = (children as any).findIndex(({ props: { selected } }) => selected);

        return React.cloneElement(child as any, {
          variant:
            variant || // The global variant always wins
            (selectedIndex === index
              ? 'active'
              : selectedIndex > index
              ? 'complete'
              : 'incomplete'),
        });
      })}
    </StyledStepList>
  );
};

StepList.tabsRole = 'TabList';
